export default __webpack_public_path__ + "static/media/five.590fcd44.jpeg";